const ONBOARDING_ROOT_SELECTOR = ".native-v3-onboarding-highlight";

export function preventNativeOnboardingDismiss(event) {
  const target = event?.detail?.originalEvent?.target;
  if (typeof Element !== "undefined" && target instanceof Element && target.closest(ONBOARDING_ROOT_SELECTOR)) {
    event.preventDefault();
  }
}
